// extracted by mini-css-extract-plugin
export default {"input-fields":"booking_input-fields__Q1Tw6","guests-menu-card":"booking_guests-menu-card__bMXWu"};